import { Injectable } from '@angular/core';
import { HttpEvent, HttpEventType, HttpResponse } from "@angular/common/http";
import { CacheTypes } from './cache-headers';
import { CachingStorage, CachedItem, toAbsoluteUrl } from './cache.service';
import { of } from 'rxjs';

export interface SerializedCachedItem {
  response: object;
  expireAt: string;
  url: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocalStorageCachingStorageService implements CachingStorage {

  prefix: string = 'E29CD455-5E53-4A0C-957D-DCFB97EB6C93_';

  get name() : string
  {
    return CacheTypes.LocalStorage;
  }

  get(key: string): CachedItem | null {
    const json = localStorage.getItem(`${this.prefix}${key}`);
    if (json === null)
      return null;
    try {
      const value: SerializedCachedItem = JSON.parse(json) as SerializedCachedItem;
      const cachedItem: CachedItem = {
        response: of(new HttpResponse<any>({ ...value.response })),
        expireAt: new Date(value.expireAt),
        url: toAbsoluteUrl(value.url)
      };
      return cachedItem;
    } catch(error) {
      localStorage.removeItem(`${this.prefix}${key}`);
      console.error(error);
    }
    return null;
  }
  
  put(key: string, value: CachedItem): void {
    const { expireAt, url } = value;
    value.response.subscribe((response: HttpEvent<any>) => {
      if (response.type != HttpEventType.Response) return
      const toSerialize = { response, expireAt, url };
      localStorage.setItem(`${this.prefix}${key}`, JSON.stringify(toSerialize));
    })
  }

  delete(key: string): void {
    localStorage.removeItem(`${this.prefix}${key}`);
  }

  getKeys(): string[] {
    const keys = Object.keys(localStorage)
      .filter(k => k.startsWith(this.prefix))
      .map(k => k.replace(this.prefix, ''));
    return keys;
  }

  clear(): void {
    const keys = this.getKeys();
    for (const key of keys) {
      this.delete(key);
    }
  }
}
